const TestingType = {
  SET_TESTING_REQUESTS_TODOLIST: 'SET_TESTING_REQUESTS_TODOLIST',
  SET_TESTING_TODO_LIST_COUNT: 'SET_TESTING_TODO_LIST_COUNT',
  SET_TODO_LIST_COUNT: 'SET_TODO_LIST_COUNT',
  SET_FILTER_SORT_DATA: 'TESTING_TODO_SET_FILTER_SORT_DATA',
  SET_SELECTED_IDS_ARRAY: 'SET_SELECTED_IDS_ARRAY',
  GET_SEASONS: 'GET_SEASONS',
  GET_MASTERS_BRANDS: 'GET_MASTERS_BRANDS',
  GET_ALL_CATEGORY_1: 'GET_ALL_CATEGORY_1',
  GET_ALL_CATEGORY_2: 'GET_ALL_CATEGORY_2',
  GET_ALL_CATEGORY_3: 'GET_ALL_CATEGORY_3',
  GET_ALL_CATEGORY_4: 'GET_ALL_CATEGORY_4',
  GET_USER_SUPPLIERS: 'GET_USER_SUPPLIERS',
  GET_SUPPLIER: 'GET_SUPPLIER',
};

export default TestingType;
